// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/inventory/raw-materials/archive',
        component: () =>
            import('@/pages/[organisation]/inventory/raw-materials/archive.vue'),
        name: 'inventory.raw-materials.archived-raw-materials',
        meta: {
            loginRequired: true,
            permission: 'access.manufacturing.raw-material.update-raw-material',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/raw-materials/archive/[id].vue'),
                name: 'inventory.raw-materials.view-archived-raw-material',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.raw-material.update-raw-material',
                },
            },
        ],
    },
    {
        path: '/:organisation/inventory/raw-materials',
        component: () =>
            import('@/pages/[organisation]/inventory/raw-materials/index.vue'),
        name: 'inventory.raw-materials.search-raw-materials',
        meta: {
            loginRequired: true,
            permission: 'access.manufacturing.raw-material.view-raw-materials',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/raw-materials/new.vue'),
                name: 'inventory.raw-materials.create-raw-material',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.raw-material.create-raw-material',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/raw-materials/[id].vue'),
                name: 'inventory.raw-materials.view-raw-material',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.raw-material.view-raw-materials',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/inventory/raw-materials/[id]/edit.vue'),
                name: 'inventory.raw-materials.update-raw-material',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.raw-material.update-raw-material',
                },
            },
        ],
    },
];
